/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Components, Theme } from "@mui/material/styles";

export const muiChipStyle = (theme: Theme): Components<Theme>["MuiChip"] => ({
  defaultProps: {
    color: "secondary",
    variant: "outlined",
  },
  styleOverrides: {
    root: {
      height: "2.25rem",
      borderRadius: "2rem",
      borderWidth: "0.125rem",
      color: theme.palette.text.primary,
      [theme.breakpoints.up("sm")]: {
        height: "2.5rem",
      },
    },
    label: {
      [theme.breakpoints.up("sm")]: {
        paddingLeft: "0.875rem",
        paddingRight: "0.875rem",
      },
    },
  },
});
